require('./scoringRulesEditorHeader.tpl.html');
require('./scoringRulesEditorHeaderController.js');
require('../scoringRulesEditorModel.js');
require('../scoringRuleActionsUtil.js');
require('./scoringRulesEditorHeader.i18n.json');

const ScoringRulesEditorHeaderComponent = {
    templateUrl: '/configuration/scoringRules/header/scoringRulesEditorHeader.tpl.html',
    controller: 'scoringRulesEditorHeaderController',
    bindings: {}
};

angular.module('ums')
    .component('uiScoringRulesEditorHeaderComponent', ScoringRulesEditorHeaderComponent);
